import { render } from "./EditCasier.vue?vue&type=template&id=15d8f124&ts=true"
import script from "./EditCasier.vue?vue&type=script&lang=ts"
export * from "./EditCasier.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__